module.exports = __webpack_public_path__ + "static/media/10.74ea1c62.png";